import { ApiService } from '@abb-procure/api';
import { Injectable } from '@angular/core';
import { array as ioArray } from 'io-ts';
import { SupplierLookupPaginatedResponseModel } from '../models/supplier-lookup-paginated-response.model';
import { SupplierContactModel } from '../models/supplier/supplier-contact.model';
import { AvailableSupplierRequest } from '../types/available-supplier-request.type';
import { SearchSupplierRequest } from '../types/search-supplier-request.type';
import { SupplierLookupPaginatedResponse } from '../types/supplier-lookup-paginated-response.type';
import { SupplierContact } from '../types/supplier/supplier-contact.type';

@Injectable({
  providedIn: 'root',
})
export class SupplierLookupApiService extends ApiService {
  async getSuppliersBase(
    request: AvailableSupplierRequest,
  ): Promise<SupplierLookupPaginatedResponseModel | null> {
    try {
      const response = await this.put<
        SupplierLookupPaginatedResponseModel,
        AvailableSupplierRequest
      >(
        'supplier/directory/available',
        SupplierLookupPaginatedResponse,
        request,
      );

      return response
        ? new SupplierLookupPaginatedResponseModel(response)
        : null;
    } catch (error) {
      return this.catchError(
        error,
        'There was an issue retrieving the list of suppliers.',
      );
    }
  }

  async getSuppliersOrganisation(
    request: SearchSupplierRequest,
  ): Promise<SupplierLookupPaginatedResponseModel | null> {
    try {
      const response = await this.put<
        SupplierLookupPaginatedResponseModel,
        SearchSupplierRequest
      >('supplier/directory/search', SupplierLookupPaginatedResponse, request);

      return response
        ? new SupplierLookupPaginatedResponseModel(response)
        : null;
    } catch (error) {
      return this.catchError(
        error,
        'There was an issue retrieving the list of suppliers.',
      );
    }
  }

  async getContacts(
    supplierId: string,
  ): Promise<SupplierContactModel[] | null> {
    try {
      const response = await this.get<SupplierContactModel[]>(
        `supplier/${supplierId}/contact`,
        ioArray(SupplierContact),
      );

      return response != null
        ? response.map((item) => new SupplierContactModel(item))
        : null;
    } catch (error) {
      return this.catchError(
        error,
        'There was an issue while retrieving the list of supplier contacts.',
      );
    }
  }
}
